<template>
  <form @submit.prevent="handleSubmit" class="max-w-xl mx-auto p-8 md:p-12 my-10 rounded-lg shadow-2xl">
    <div class="flex flex-col my-2">
      <label for="name" class="text-sm mb-1">Name:</label>
      <input id="name" v-model="formData.name" type="text" class="py-2 px-3 rounded outline-none focus:ring-2 focus:ring-indigo-500" required>
    </div>
    <div class="flex flex-col my-2">
      <label for="email" class="text-sm mb-1">Email:</label>
      <input id="email" v-model="formData.email" type="email" class="py-2 px-3 rounded outline-none focus:ring-2 focus:ring-indigo-500" required>
    </div>
    <div class="flex flex-col my-2">
      <label for="phone" class="text-sm mb-1">Phone:</label>
      <input id="phone" v-model="formData.phone" type="text" class="py-2 px-3 rounded outline-none focus:ring-2 focus:ring-indigo-500" required>
    </div>
    <div class="flex flex-col my-2">
      <label for="message" class="text-sm mb-1">Message:</label>
      <textarea id="message" v-model="formData.message" class="py-2 px-3 rounded outline-none focus:ring-2 focus:ring-indigo-500" required></textarea>
    </div>
    <button type="submit" class="w-full py-3 bg-indigo-600 mt-4 text-white rounded hover:bg-indigo-500">Send</button>
  </form>
</template>

<script>
export default {
  name: 'ContactForm',
  data() {
    return {
      formData: {
        name: '',
        email: '',
        phone: '',
        message: '',
      }
    }
  },
  methods: {
    async handleSubmit() {
      try {
        const response = await fetch('/contact', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(this.formData)
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        } else {
          const jsonData = await response.json();
          console.log('Message from the server: ', jsonData.status);

          // Reset form after successful submission
          this.formData = {
            name: '',
            email: '',
            phone: '',
            message: '',
          }
          alert('Thank you for your message. We will get back to you soon!');
        }
      } catch (error) {
        console.error('There was a problem with the fetch operation: ' + error.message);
      }

    }
  }
}
</script>